import React, { useState, useContext } from 'react';
import { Nav } from './Nav';
import { Navigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { GlobalContext } from '../context/GlobalState';
import { Message } from './Message';
import { API_BASE_URL } from '../utils/apiBaseUrl';

export const LogInForm = () => {
  const { handleLoggedIn, showNotification } = useContext(GlobalContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [userId, setUserId] = useState('');

  const handleSubmit = async event => {
    event.preventDefault();

    if (!email.trim() || !password) {
      const message = 'Email and password are required.';
      setErrorMessage(message);
      showNotification(message, 'warning');
      return;
    }

    const userData = {
      email,
      password,
    };

    try {
      setIsSubmitting(true);
      setErrorMessage('');

      const response = await fetch(`${API_BASE_URL}/users/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const data = await response.json();

      if (!response.ok || !data?.userId) {
        const message =
          data?.message || 'Login failed. Please check your credentials.';
        setErrorMessage(message);
        showNotification(message, 'error');
        return;
      }

      setErrorMessage('');
      setUserId(data.userId);
      handleLoggedIn(data.userId, data.email);
    } catch (error) {
      const message = 'Login request failed. Please try again.';
      setErrorMessage(message);
      showNotification(message, 'error');
      console.error('Error logging in user:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Nav />
      <form onSubmit={handleSubmit}>
        <div className='form-item'>
          <label htmlFor='email'>Email:</label>
          <input
            type='email'
            id='email'
            value={email}
            onChange={event => setEmail(event.target.value)}
          />
        </div>
        <div className='form-item'>
          <label htmlFor='password'>Password:</label>
          <input
            type='password'
            id='password'
            value={password}
            onChange={event => setPassword(event.target.value)}
          />
        </div>
        <button type='submit' disabled={isSubmitting}>
          {isSubmitting ? 'Signing in...' : 'Sign In'}
        </button>
        {errorMessage && (
          <Message className='message-error' text={errorMessage} />
        )}
        <p className='auth-switch'>
          No account yet? <Link to='/register'>Create Account</Link>
        </p>
      </form>
      {userId && <Navigate to='/user/home' replace={true} />}
    </>
  );
};
